NtechApp.ResumeFormNav = function($view) {
    var me = this;

    this._$view = null;
    this._click = null;

    this._nextCollectionFieldId = ++NtechApp.ResumeFormNav.NEXT_COLLECTION_FIELD_ID;
    this._nextCollectionSubfieldId = 100000;

    this._construct = function() {
        me._$view = $view;

        me._click = new NtechApp.TouchClickEvent();
        me._updateMenuControls();

        me._bindEvents();
    }

    this._bindEvents = function() {
        me._click.listen(me._$view, "[data-addNewTrigger]", function(e) {
            var $newForm = me._addNextForm($(e.target).closest("[data-multipleFormNav]"));
            me._hideEmptyForm();
            me._showForm($newForm);

            me._bindFormSelects($newForm);
            me._bindFormRadios($newForm);
            me._bindFormSingleFileUploaders($newForm);
            me._bindFormPhones($newForm);

            var $newMenuItem = me._addMenuItem($newForm);
            me._selectMenuItem($newMenuItem);
            me._updateMenuControls();

            me._updateMenuIndexes();
            me._updateTabIndexes();

            NtechApp.scrollToPx(0);
            $(me).trigger(NtechApp.ResumeFormNav.EVENT_FORM_ADD, [$newForm]);
        });

        me._click.listen(me._$view.find("[data-formNavRoot]"), "[data-formRow]", function(e) {
            var $item = $(e.target).closest("[data-formRow]");
            if($item.hasClass("selected") || $item.attr("data-formRow") == "empty")
                return;

            me._showForm(me._$view.find("[data-formTab='" + $item.attr("data-formRow") + "']"));
            me._selectMenuItem($item);
        });

        me._click.listen(me._$view, "[data-rmTrigger]", function() {
            NtechApp.confirmForm.load(function() {
                NtechApp.confirmForm.unload();
                me._removeCurrentForm.call(me);
                me._selectLastForm.call(me);
                me._updateMenuControls();
                me._updateMenuIndexes();
                me._updateTabIndexes();
            });
        });
    }

    this._unbindEvents = function() {
        ;
    }

    this.destruct = function() {
        me._unbindEvents();
    }

    this._construct();
    return this;
};

NtechApp.ResumeFormNav.EVENT_FORM_ADD = "NtechApp.ResumeFormNav.EventFormNav";
NtechApp.ResumeFormNav.NEXT_COLLECTION_FIELD_ID = 0;

NtechApp.proto(NtechApp.ResumeFormNav, {
    //_getFormsCount: function() {
    //    // Form with empty data
    //    var emptyFormCount = 1;
    //    return this._$view.find("[data-formTab]").length - emptyFormCount;
    //},

    _getNextFormIndex: function() {
        // Form with empty data
        var emptyFormCount = 1;
        var tabsCount = this._$view.find("[data-formTab]").length - emptyFormCount;
        if(tabsCount == 0)
            return 0;

        return parseInt(this._$view.find("[data-formTab]").last().attr("data-formTab"), 10) + 1;
    },

    _addNextForm: function($form) {
        var prototype = $form.attr("data-prototype");

        //var nextFormIndex = this._getFormsCount() + 1;
        //var nextFormIndex = this._getFormsCount() + 1;
        //var nextFormFieldsIndex = this._getFormsCount();
        var nextFormIndex = this._getNextFormIndex();
        var nextFormFieldsIndex = this._getNextFormIndex();
        var nextFormHtml = prototype.replace(/__name__/g, nextFormFieldsIndex);

        //var formClass = (nextFormIndex == 1) ? "" : "hidden";
        var formClass = "";
        nextFormHtml = nextFormHtml.replace(/__formClass__/g, formClass);

        nextFormHtml = nextFormHtml.replace(/__formIndex__/g, nextFormIndex);
        var $newForm = $($.parseHTML($.trim(nextFormHtml)));

        var $lastForm = this._$view.find("[data-formTab]").last();
        $lastForm.after($newForm);

        return $newForm;
    },

    _showEmptyForm: function() {
        var $formNav = this._$view.find("[data-formNavRoot]");
        $formNav.find("[data-formRow='empty']").css("display", "block");

        this._$view.find("[data-formTab='e']").css("display", "block");
    },

    _hideEmptyForm: function() {
        var $formNav = this._$view.find("[data-formNavRoot]");
        $formNav.find("[data-formRow='empty']").css("display", "none");

        this._$view.find("[data-formTab='e']").css("display", "none");
    },

    _showForm: function($form) {
        this._$view.find("[data-formTab]").css("display", "none");
        $form.css("display", "block");
    },

    _formatPrototypeDefId: function(id) {
        return id.replace(/\d/g, "");
    },

    _getNextFieldId: function() {
        this._nextCollectionSubfieldId++;
        return this._nextCollectionFieldId.toString() + this._nextCollectionSubfieldId.toString();
    },

    _bindFormSelects: function($newForm) {
        var me = this;

        $.each($newForm.find("[data-customSelectId]"), function() {
            var oldSelectId = $(this).attr("data-customSelectId");
            var selectId = me._formatPrototypeDefId($(this).attr("data-customSelectId"));

            var $selectTextInput = $(this);
            var $selectHiddenInput = $newForm.find("[data-customSelectHiddenId='" + oldSelectId + "']");

            var selectHiddenId = me._formatPrototypeDefId(
                $selectHiddenInput.attr("data-customSelectHiddenId")
            );
            var selectIndex = me._getNextFieldId();

            $selectTextInput.attr("data-customSelectId", selectId + selectIndex);
            $selectHiddenInput.attr("data-customSelectHiddenId", selectHiddenId + selectIndex);

            NtechApp.formManager.bindFormSelect($selectTextInput);
        });
    },

    _bindFormRadios: function($newForm) {
        var me = this;

        $.each($newForm.find("[data-customRadioId]"), function() {
            var oldRadioId = $(this).attr("data-customRadioId");
            var radioId = me._formatPrototypeDefId($(this).attr("data-customRadioId"));

            var $radioWrapper = $(this);
            var $radioHiddenInput = $newForm.find("[data-customRadioHiddenId='" + oldRadioId + "']");

            var radioHiddenId = me._formatPrototypeDefId(
                $radioHiddenInput.attr("data-customRadioHiddenId")
            );
            var radioIndex = me._getNextFieldId();

            $radioWrapper.attr("data-customRadioId", radioId + radioIndex);
            $radioHiddenInput.attr("data-customRadioHiddenId", radioHiddenId + radioIndex);

            NtechApp.formManager.bindFormRadio($radioWrapper);
        });
    },

    _bindFormSingleFileUploaders: function($newForm) {
        var me = this;

        $.each($newForm.find("[data-singleFileUploader]"), function() {
            var oldFileId = $(this).attr("data-singleFileUploader");
            var fileId = me._formatPrototypeDefId($(this).attr("data-singleFileUploader"));

            var $fileWrapper = $(this).closest("form");
            var $fileHiddenInput = $fileWrapper.find("[data-singleFileHiddenId='" + oldFileId + "']");
            var $fileInfoWrapper = $fileWrapper.find("[data-singleFileUploaderImage='" + oldFileId + "']");
            var $filePreviewWrapper = $fileWrapper.find("[data-singleFileUploaderInfo='" + oldFileId + "']");

            var newFileIndex = me._getNextFieldId();;
            var newFileId = fileId + newFileIndex;

            $(this).attr("data-singleFileUploader", newFileId);
            $fileHiddenInput.attr("data-singleFileHiddenId", newFileId);
            $fileInfoWrapper.attr("data-singleFileUploaderImage", newFileId);
            $filePreviewWrapper.attr("data-singleFileUploaderInfo", newFileId);

            NtechApp.formManager.bindSingleFieldUploader($(this));
        });
    },

    _bindFormPhones: function($newForm) {
        $.each($newForm.find("[data-phoneCustomInput]"), function() {
            NtechApp.formManager.bindFormPhones($(this));
        });
    },

    _addMenuItem: function($newForm) {
        var formIndex = $newForm.attr("data-formTab");
        var $formNav = this._$view.find("[data-formNavRoot]");

        //var itemLabel = formIndex + "." + $formNav.attr("data-listItemPrototype");

        var $newItem = $("<div/>").addClass("listItem").attr("data-formRow", formIndex);
        //$newItem.text(itemLabel);
        var $index = $("<span/>").addClass("index").text(formIndex);
        var $label = $("<span/>").addClass("label").text($formNav.attr("data-listItemPrototype"));
        $newItem.append($index).append(".").append($label);

        $formNav.find("[data-formRow]").last().after($newItem);

        return $newItem;
    },

    _selectMenuItem: function($item) {
        var $formNav = this._$view.find("[data-formNavRoot]");
        $formNav.find("[data-formRow]").removeClass("selected");

        $item.addClass("selected");
    },

    _updateMenuControls: function() {
        var formAction = this._$view.attr("data-formAction");
        var newAction = false;
        var editAction = false;

        if(formAction == "new")
            newAction = true;
        else if(formAction == "edit")
            editAction = true;

        var $formMainNav = this._$view.find("[data-formNavRoot]");
        var $items = $formMainNav.find("[data-formRow]");

        var $formNav = this._$view.find("[data-formNavControlsRoot]");

        if(newAction) {
            // Empty form is active
            if ($items.length == 1) {
                $formNav.find("[data-addControl]").removeClass("hiddenItem");
                $formNav.find("[data-rmControl]").addClass("hiddenItem");
            }
            // Another form is active
            else {
                $formNav.find("[data-addControl]").addClass("hiddenItem");
                $formNav.find("[data-rmControl]").removeClass("hiddenItem");
            }
        }
        else {
            $formNav.find("[data-addControl]").removeClass("hiddenItem");
            $formNav.find("[data-rmControl]").removeClass("hiddenItem");
        }
    },

    _updateMenuIndexes: function() {
        var $formMainNav = this._$view.find("[data-formNavRoot]");
        var $items = $formMainNav.find("[data-formRow]");

        var i = 0;
        $.each($items, function() {
            if($(this).attr("data-formRow") == "empty")
                return true;

            $(this).find(".index").text(++i);
            //$(this).attr("data-formRow", i);
        });
    },

    // Form tab indexes should be in sync with collection field indexes
    _updateTabIndexes: function() {
        //var $items = this._$view.find("[data-formTab]");
        //
        //var i = 0;
        //$.each($items, function() {
        //    if($(this).attr("data-formTab") == "e")
        //        return true;
        //
        //    $(this).attr("data-formTab", ++i);
        //});
    },

    _removeCurrentForm: function() {
        var $formNav = this._$view.find("[data-formNavRoot]");
        var $selectedItem = $formNav.find("[data-formRow]").filter(function () {
            return $(this).hasClass("selected");
        });

        var $selectedForm = this._$view.find("[data-formTab='" + $selectedItem.attr("data-formRow") + "']");

        // @todo -> unbind custom selects and radios
        $selectedItem.remove();
        $selectedForm.remove();
    },

    _selectLastForm: function() {
        var $formNav = this._$view.find("[data-formNavRoot]");
        var $lastItem = $formNav.find("[data-formRow]").last();

        var hasForms = $lastItem.attr("data-formRow") != "empty";

        if(hasForms) {
            $lastItem.addClass("selected");
            this._showForm(this._$view.find("[data-formTab='" + $lastItem.attr('data-formRow') + "']"));
        }
        else {
            this._showEmptyForm();
        }
    }
});